import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IExtendPagination, PaginatedResult } from '../Pagination/IPagination';
import { IIndexAccount } from '../Models/IAccount';
import { getPaginationHeaders, getPaginationResult } from '../Pagination/getPaginationResult';

@Injectable({
    providedIn: 'root',
})
export class BuyerService {
    private baseBuyerUrl = `${environment.api}/buyersAccount`;

    private _buyersListForOrder$: BehaviorSubject<PaginatedResult<IIndexAccount[]> | null> = new BehaviorSubject(null);
    private _accountRewardAmount$: BehaviorSubject<number> = new BehaviorSubject(0);


    get getBuyersListForOrder$(): Observable<PaginatedResult<IIndexAccount[]>> {
        return this._buyersListForOrder$.asObservable();
    }

    get getAccountReward$(): Observable<number>
    {
        return this._accountRewardAmount$.asObservable();
    }

    constructor(private _httpClient: HttpClient) {}

    buyersList(pramas?: IExtendPagination): Observable<PaginatedResult<IIndexAccount[]>> {
        const params = getPaginationHeaders(pramas.currentPage,pramas.pageSize);
        return this.loadBuyers(params);
    }

    loadBuyers(params: HttpParams): Observable<PaginatedResult<IIndexAccount[]>> {
        const result = getPaginationResult<IIndexAccount[]>(`${this.baseBuyerUrl}`,params,this._httpClient)
        .pipe(tap((buyers) =>
            {
                this._buyersListForOrder$.next(buyers);
            })
        );
        return result;
    }

    searchBuyers(
        pramas?: IExtendPagination
    ): Observable<PaginatedResult<IIndexAccount[]>> {
        let params = getPaginationHeaders(pramas.currentPage, pramas.pageSize);

        if (pramas.searchTerm && pramas.searchTerm !== '') {
            params = params.append('searchTerm', pramas.searchTerm.toString());
        }

        return this.loadBuyers(params);
    }


    accountReward(userId: string): Observable<number>
    {
        return this._httpClient.get<number>(`${this.baseBuyerUrl}/AccountReward/${userId}`)
        .pipe(
            tap((reward)=>{
                this._accountRewardAmount$.next(reward);
            })

        );
    }

    
}
